/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Heading1Inputs */

const ja_playdata_eventreport_example_heading1 = /** @type {(inputs: Playdata_Eventreport_Example_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツ大会分析レポートの例`)
};

const en_playdata_eventreport_example_heading1 = /** @type {(inputs: Playdata_Eventreport_Example_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the report includes`)
};

/**
* | output |
* | --- |
* | "What the report includes" |
*
* @param {Playdata_Eventreport_Example_Heading1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_heading1 = /** @type {((inputs?: Playdata_Eventreport_Example_Heading1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Heading1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_heading1(inputs)
	return en_playdata_eventreport_example_heading1(inputs)
});
export { playdata_eventreport_example_heading1 as "playdata_eventReport_example_heading" }